module.exports = __webpack_public_path__ + "img/icon_plus@3x.2c2723df.png";